import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { BrandLogo } from "@/data/BrandLogo";
import {
  PatentWrapper,
  Title,
  BrandGrid,
  BrandBox,
  BannerWrapper,
  ProductListWrapper,
  ProductBox,
} from "./brand.styles";
import { ProductsApi } from "@api/products";

export const MainBrand = ({ userDevice }) => {
  const router = useRouter();
  const [activeIdx, setActiveIdx] = useState(0);
  const [productData, setProductData] = useState([]);

  const activeBrand = BrandLogo[activeIdx];

  useEffect(() => {
    if (!activeBrand?.pcode) return;

    const fetchData = async () => {
      const body = {
        modes: "MultiListSet",
        items: activeBrand.pcode,
      };
      try {
        const res = await ProductsApi(body);
        setProductData(Object.values(res.Data.Data));
      } catch (e) {
        console.error("상품 데이터 가져오기 실패:", e);
      }
    };

    fetchData();
  }, [activeIdx]);

  return (
    <PatentWrapper>
      <Title className="container row">
        <h4>제휴 브랜드</h4>

        <BrandGrid>
          {BrandLogo.map((brand, idx) => (
            <BrandBox key={idx} onClick={() => setActiveIdx(idx)}>
              <img
                src={activeIdx === idx ? brand.activeSrc : brand.inactiveSrc}
                alt={`브랜드 로고 ${idx}`}
              />
            </BrandBox>
          ))}
        </BrandGrid>

        {/* 메인 배너 이미지 */}
        {userDevice === "web" && (
          <BannerWrapper>
            <img
              src={activeBrand.mainBannerImg}
              alt="브랜드 배너"
              onClick={() => router.push(`${activeBrand.mainBannerUrl}`)}
            />
          </BannerWrapper>
        )}

        {/* 상품 리스트 */}
        <ProductListWrapper>
          {productData.map((item) => (
            <ProductBox key={item.pcode}>
              <img
                src={item.main_image}
                alt={item.name}
                onClick={() =>
                  router.push(`/products/${item.ename}/${item.pcode}/`)
                }
              />
            </ProductBox>
          ))}
        </ProductListWrapper>
      </Title>
    </PatentWrapper>
  );
};
